<template>
  <div
    class="main"
    v-infinite-scroll="loadmore"
    :infinite-scroll-disabled="busy"
    :infinite-scroll-distance="10"
  >
    <div style="width: 100%;height:50px;padding:10px 20px;">
      搜索：
      <a-input-search
        placeholder="请输入您要搜索的关键词"
        style="width: 400px;margin-right: 20px"
        v-model="param.keyword"
        @search="onSearch"
        @keyup.esc="reset"
      />
      <a-button type="primary" @click="reset()">重置</a-button>
    </div>
    <div class="uploads" style="overflow-y: hidden">
      <a-upload-dragger
        accept="image/*"
        name="file"
        :multiple="false"
        :headers="headers"
        :beforeUpload="beforeUpload"
      >
        <a-icon type="upload" ref="imgupload" /> 点击上传图片
      </a-upload-dragger>
    </div>
    <div class="lists">
      <ul>
        <li
          v-for="(item, index) in picLists"
          :key="index"
          class="img-lists"
          @click="showModal(item)"
        >
          <div class="imgs">
            <img :src="item.url + '/thumb_400'" alt="" />
          </div>
          <div class="title">{{ item.filename }}</div>
        </li>
      </ul>
    </div>

    <a-modal
      v-model="visible"
      :title="'图片名称：' + showImg.title"
      onOk="handleOk"
      width="1000px"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">返回</a-button>
        <a-button
          key="submit"
          type="danger"
          :loading="loading"
          @click="showConfirm(showImg.id)"
        >
          删除
        </a-button>
      </template>
      <a-row>
        <a-col
          :span="16"
          style="text-align: center;height:500px;line-height: 500px"
        >
          <img
            :src="showImg.src"
            alt=""
            style="max-width: 600px;max-height: 500px;"
          />
        </a-col>
        <a-col :span="8">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ showImg.title }}</span>
            </template>
            <p
              style="width:300px;overflow-x: hidden;white-space:nowrap;text-overflow: ellipsis;"
            >
              标题：{{ showImg.title }}
            </p>
          </a-tooltip>

          <!--                    <p>上传人：张三</p>-->
          <!--                    <p>上传时间：2019-05-04 00:00:00</p>-->
        </a-col>
        <a-col>调用预览：</a-col>
        <a-col class="img-style">
          <a-button @click="() => (this.style = '480_320')">480*320</a-button>
          <a-button @click="() => (this.style = '640_360')">640*360</a-button>
          <a-button @click="() => (this.style = '640_320')">640*320</a-button>
          <a-button @click="() => (this.style = '600_200')">600*200</a-button>
        </a-col>
        <a-col style="height: 300px;line-height: 300px">
          <img :src="showImg.src + '/' + style" alt="" width="300" />
        </a-col>
      </a-row>
      <a-row type="flex" justify="space-around" align="middle">
        <a-col :span="23"> 原始图片路径：<a-input :value="showImg.src"/></a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll';
export default {
  name: 'Picture',
  directives: { infiniteScroll },
  data() {
    return {
      style: '480_320',
      showImg: { title: '', src: '', id: '' },
      loading: false,
      visible: false,
      param: { page: 0, limit: 50, keyword: '' },
      picLists: [],
      headers: {
        Authorization: window.localStorage.getItem('token')
      },
      busy: false
    };
  },
  created() {
    this.getPicLists();
  },
  methods: {
    onSearch() {
      this.param.page = 1;
      this.picLists = [];
      this.getPicLists();
      // console.log('onsearch')
    },
    reset() {
      this.param.keyword = '';
      this.param.page = 1;
      this.picLists = [];
      this.getPicLists();
    },
    showConfirm(id) {
      let that = this;
      this.$confirm({
        title: '确定删除图片吗?',
        content: '删除后将无法通过任何办法找回，确定吗？',
        onOk() {
          that.$http.post('api/AliyunOss/FileDel', { id: id }).then(res => {
            if (res.data.state == 200) {
              that.$message.success('已删除');
              that.visible = false;
              that.param.page = 1;
              that.busy = false;
              that.getPicLists();
            }
          });
        },
        onCancel() {}
      });
    },
    handleCancel(e) {
      this.visible = false;
    },
    showModal(item) {
      this.showImg = {
        title: item.filename,
        src: item.url.replace(/http:/g, ''),
        id: item.id
      };
      this.visible = true;
    },
    loadmore() {
      this.getPicLists();
    },
    async beforeUpload(file) {
      let res = await this.$http.post(
        'https://openapi.ycrmt.cn/aliyun/index/Imgesupload'
      );
      let data = res.data.data;
      let client = new this.$OSS({
        region: data.config.region,
        accessKeyId: data.result.Credentials.AccessKeyId,
        accessKeySecret: data.result.Credentials.AccessKeySecret,
        stsToken: data.result.Credentials.SecurityToken,
        bucket: data.config.bucket
      });
      let options = {
        callback: data.callback
      };
      options.callback.customValue.filename = file.name.substring(
        0,
        file.name.lastIndexOf('.')
      ); //原文件名称
      let date = new Date();
      let year = this.$moment().format('YYYY');
      let month = this.$moment().format('MM');
      let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      let result = await client.put(
        data.path +
          year +
          '/' +
          month +
          '/' +
          this.$md5(date) +
          '.' +
          fileExtension,
        file,
        options
      );
      if (result.data.errno === 0) {
        this.$message.success('文件上传成功');
        this.busy = false;
        this.picLists = [];
        this.param.page = 1;
        this.getPicLists();
      } else {
        this.$$message.error('文件上传失败');
      }
    },
    goUpload() {
      this.$refs.imgupload.click();
    },
    getPicLists() {
      if (!this.busy) {
        this.busy = true;
        this.$http.post('/api/AliyunOss/lists', this.param).then(res => {
          if (res.data.state == 200) {
            if (this.param.page == 1) {
              this.picLists = [];
            }
            for (let i in res.data.data) {
              res.data.data[i].url = res.data.data[i].url.replace(
                /wf.cdn.ycrmt.cn/,
                'cdn.ycrmt.cn'
              );
              this.picLists.push(res.data.data[i]);
            }
            this.param.page++;
            this.busy = false;
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 42px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  background-color: #fff;
  /*padding-top:10px*/
}

.uploads {
  float: left;
  width: 205px;
  height: 175px;
  margin: 10px;
  padding-top: 5px;
}

.lists {
  margin: 0 10px;
}
.lists ul li {
  float: left;
  width: 205px;
  height: 175px;
  text-align: center;
  cursor: pointer;
  padding: 0 10px;
  margin-bottom: 10px;
}
.lists ul li.img-lists:hover {
  background-color: #f2f6fc;
}
.lists .imgs {
  height: 145px;
  line-height: 145px;
}
.lists .title {
  /*height:28px;*/
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 28px;
  font-size: 14px;
  color: #606266;
}
.lists ul li:hover .title {
  color: #409eff;
}
.lists ul li img {
  vertical-align: middle;
  max-width: 145px;
  max-height: 145px;
  border-radius: 5px;
}
.img-style button {
  margin: 5px 10px 0 0;
}
.uploads i {
  margin: 40px 20px 20px 20px;
  display: block;
  font-size: 50px;
  color: #40a9ff;
}
</style>
